import axios from 'axios'
import { apiUrl } from '../../config'
import authenticationStore from '../../stores/authenticationStore'

export const ResourcesRequest = {
  create: data =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/resources/`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data,
    }),
  move: (srcId, desId) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/resources/move/${srcId}/${desId}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  moveToRoot: srcId =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/resources/move/${srcId}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  rename: (id, newName) =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/resources/rename/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: { name: newName },
    }),
  share: data =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/resources/share/${data.id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data,
    }),
  delete: id =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/resources/${id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  published: data =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/resources/published/${data.id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data,
    }),
  search: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/resources/`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params,
    }),
  shareList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/resources/share`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params,
    }),
}

